import axios from "../axiosClient";

export const getAllSites = async (
  signal: any,
  PageNumber: any = 0,
  pageSize: any = 0
) => {
  const res = await axios.get(`/slpapp/Site/getall`, {
    params: { PageNumber, pageSize },
    signal,
  });

  return res?.data;
};

export const getAllContactRole = async (signal: any) => {
  const res = await axios.get(`/slpapp/BlockContactRole`, {
    signal,
  });

  return res?.data;
};
